import loadable from '@loadable/component';
import FullPageLoading from '../../../components/Loading/FullPageLoading';
import { ORGANISATION_SETTINGS_PATHNAME } from '../organisation-settings/organisation-settings.loadable.js';

export const ORGANISATION_GROUP_PATH = `${ORGANISATION_SETTINGS_PATHNAME}/:groupId`;

export const OrganisationGroupLoadable = loadable(async () => import('./organisation-group.view'), {
  fallback: <FullPageLoading />,
});
